const applyInputHover = function (form) {
    const $form = $(form);
    $form.find(".float-label .fromInput").each(function () {
        checkInputValue(this);
    });

    $form.find(".select-focus").on("change", function () {
        checkInputValue(this);
    });

    // function for set input class if not empty
    $form.find(".fromInput").on("keyup", function () {
        checkInputValue(this);
    }).on('focus', function () {
        const x = $(this);
        if (x.val() === "") {
            x.parent(".float-label").addClass("focus");
        }
    }).on('focusout', function () {
        const x = $(this);
        if (x.val() === "") {
            x.parent(".float-label").removeClass("focus");
        }
    });
}

function checkInputValue(input, autoFilled) {
    const x = $(input);
    if ((typeof autoFilled !== 'undefined' && autoFilled) || x.val() !== "") {
        x.parent(".float-label").addClass("filled").removeClass("empty");
    } else {
        x.parent(".float-label").addClass("empty").removeClass("filled");
        x.parent(".float-label").removeClass("focus");
    }
}

export {
    applyInputHover,
    checkInputValue
}
